import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Endpoints, ServerResponseKeys } from '../../../api/Constants';
import { postRewardCenterAdapter, postRewardCenterHistoryAdapter, postRewardOfferHistoryDetailsAdapter, postOfferDetailAdapter } from './adapters';
import { getAssetsPackage } from '../assetsPackage';
import { validateJson } from '../../../utils/jsonschema/validator';
import HTTP from '../../../utils/httpMethods';
import { getTimeout } from '../../api/services/utils/timeout';
export var postRewardCenterMutation = {
  query: function query() {
    return {
      url: Endpoints.INIT_REWARDS,
      body: {
        timeout: getTimeout(Endpoints.INIT_REWARDS, HTTP.POST),
        cache: {
          maxAge: 1000
        }
      }
    };
  },
  providesTags: ['RewardCenter'],
  keepUnusedDataFor: 0,
  transformResponse: function () {
    var _transformResponse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(response) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!validateJson(Endpoints.INIT_REWARDS, response[ServerResponseKeys.CALL_RESPONSE])) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return", postRewardCenterAdapter(response[ServerResponseKeys.CALL_RESPONSE]));

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function transformResponse(_x) {
      return _transformResponse.apply(this, arguments);
    }

    return transformResponse;
  }(),
  onQueryStarted: function () {
    var _onQueryStarted = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref, _ref2) {
      var _ref$requestAssetsDat, requestAssetsData, dispatch, queryFulfilled, _yield$queryFulfilled, data;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _ref$requestAssetsDat = _ref.requestAssetsData, requestAssetsData = _ref$requestAssetsDat === void 0 ? null : _ref$requestAssetsDat;
              dispatch = _ref2.dispatch, queryFulfilled = _ref2.queryFulfilled;
              _context2.next = 4;
              return queryFulfilled;

            case 4:
              _yield$queryFulfilled = _context2.sent;
              data = _yield$queryFulfilled.data;

              if (!(requestAssetsData && (data === null || data === void 0 ? void 0 : data.assetsPackageId))) {
                _context2.next = 9;
                break;
              }

              _context2.next = 9;
              return dispatch(getAssetsPackage.initiate({
                assetsPackageId: data === null || data === void 0 ? void 0 : data.assetsPackageId
              }));

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function onQueryStarted(_x2, _x3) {
      return _onQueryStarted.apply(this, arguments);
    }

    return onQueryStarted;
  }()
};
export var postOfferDetailMutation = {
  query: function query(data) {
    return {
      url: "".concat(Endpoints.GET_REWARD_DETAIL).concat(data.offerId),
      method: 'post'
    };
  },
  transformResponse: function () {
    var _transformResponse2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(response, meta, arg) {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", postOfferDetailAdapter(response[ServerResponseKeys.CALL_RESPONSE], arg.rewardCenterBaseUrl));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    function transformResponse(_x4, _x5, _x6) {
      return _transformResponse2.apply(this, arguments);
    }

    return transformResponse;
  }()
};
export var postPurchaseOfferMutation = {
  query: function query(data) {
    return {
      url: Endpoints.PURCHASE_OFFER,
      method: 'post',
      body: {
        data: data
      }
    };
  },
  transformResponse: function () {
    var _transformResponse3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(response) {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", response[ServerResponseKeys.CALL_RESPONSE]);

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    function transformResponse(_x7) {
      return _transformResponse3.apply(this, arguments);
    }

    return transformResponse;
  }()
};
export var postRewardCenterHistoryMutation = {
  query: function query() {
    return {
      url: Endpoints.GET_OFFER_HISTORY
    };
  },
  providesTags: ['RewardCenter'],
  transformResponse: function () {
    var _transformResponse4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(response, meta, arg) {
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", postRewardCenterHistoryAdapter(response[ServerResponseKeys.CALL_RESPONSE], arg.rewardCenterBaseUrl));

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    function transformResponse(_x8, _x9, _x10) {
      return _transformResponse4.apply(this, arguments);
    }

    return transformResponse;
  }()
};
export var postRewardOfferHistoryDetailsMutation = {
  query: function query(data) {
    return {
      url: "".concat(Endpoints.GET_PLAYER_OFFER_DETAILS).concat(data.activeHistoryItemId),
      method: 'post'
    };
  },
  providesTags: ['RewardCenter'],
  transformResponse: function () {
    var _transformResponse5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(response) {
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt("return", postRewardOfferHistoryDetailsAdapter(response[ServerResponseKeys.CALL_RESPONSE]));

            case 1:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    function transformResponse(_x11) {
      return _transformResponse5.apply(this, arguments);
    }

    return transformResponse;
  }()
};
export var postRewardOfferHistorySendEmailMutation = {
  query: function query(data) {
    return {
      url: Endpoints.SEND_OFFER_EMAIL,
      method: 'post',
      body: {
        rpid: data.activeHistoryItemId
      }
    };
  },
  providesTags: ['RewardCenter']
};